export const environment = {
  banner: {text: 'DEV'},
  idp_url: 'https://identity-eiam-r.eiam.admin.ch/realms/efd_bit-vlp',
  redirect_url: 'https://dev.federalproof.ch',
  client_id: 'BIT-vlp',
	claims: ['given_name', 'family_name', 'email', 'acr', 'birthdate'],
  minimum_acr: 20,
  sentryEnvironment: 'dev'
};
